<template>
  <form
    class="bcc-form"
    @submit.prevent
    :class="[
      labelPosition ? 'bcc-form--label-' + labelPosition : '',
      { 'bcc-form--inline': inline },
    ]"
  >
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'BccForm',
  componentName: 'BccForm',
  props: {
    model: Object,
    rules: Object,
    labelPosition: {
      type: String,
      default: 'right'
    },
    labelWidth: {
      type: String,
      default: '80px'
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: []
    }
  },
  created () {
    this.$on('bcc.form.addField', (field) => {
      if (field) {
        this.fields.push(field)
      }
    })
    this.$on('bcc.form.removeField', (field) => {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1)
      }
    })
  },
  methods: {
    resetFields () {
      if (!this.model) {
        console.warn('[Bubble Warn][Form]model is required for resetFields to work.')
        return
      }
      this.fields.forEach(field => {
        field.resetField()
      })
    },
    clearValidate (props = []) {
      const fields = props.length
        ? (typeof props === 'string'
          ? this.fields.filter(field => props === field.prop)
          : this.fields.filter(field => props.indexOf(field.prop) > -1)
        ) : this.fields
      fields.forEach(field => {
        field.clearValidate()
      })
    },
    validate (callback) {
      if (!this.model) {
        console.warn('[Bubble Warn][Form]model is required for validate to work!')
        return
      }
      let promise
      // if no callback, return promise
      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise((resolve, reject) => {
          callback = function (valid) {
            valid ? resolve(valid) : reject(valid)
          }
        })
      }
      let valid = true
      let count = 0
      if (this.fields.length === 0 && callback) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(true)
      }
      let invalidFields = {}
      this.fields.forEach(field => {
        field.validate('', (message, field) => {
          if (message) {
            valid = false
          }
          invalidFields = Object.assign({}, invalidFields, field)
          if (typeof callback === 'function' && ++count === this.fields.length) {
            callback(valid, invalidFields)
          }
        })
      })
      if (promise) {
        return promise
      }
    },
    validateField (props, cb) {
      props = [].concat(props)
      const fields = this.fields.filter(field => props.indexOf(field.prop) !== -1)
      if (!fields.length) {
        console.warn('[Bubble Warn][Form]please pass correct props!')
        return
      }
      fields.forEach(field => {
        field.validate('', cb)
      })
    }
  }
}
</script>
